module.exports = __webpack_public_path__ + "static/media/car-4036152_640.5febf143.jpg";